export const CATEGORIES_FETCH = 'CATEGORIES_FETCH';
export const CATEGORIES_FETCH_SUCCESS = 'CATEGORIES_FETCH_SUCCESS';
export const CATEGORIES_FETCH_ERROR = 'CATEGORIES_FETCH_ERROR';
export const categoriesFetch = categoriesType => ({type: CATEGORIES_FETCH, categoriesType});

export const CATEGORY_SELECT = 'CATEGORY_SELECT';
export const categorySelect = (categoryType, categoryId) => ({type: CATEGORY_SELECT, categoryType, categoryId});



/** WEBPACK FOOTER **
 ** ./src/members/state/categories/actions.js
 **/